import ArrowIcon from '../../atoms/arrow';

import * as s from './styles';

import type { IGatsbyImageData } from 'gatsby-plugin-image';
import type { IAudienceCard } from './types';

const AudienceCard = ({ 
  titleAndUrl,
  image,
  $current,
  swipe,
  $index,
  $activeIndex,
  setThisSlide,
}: IAudienceCard) => {

  const clickHandler = (e: React.MouseEvent<HTMLDivElement> | undefined) => {
    /*
      On mobile only the swipe will not automatically follow the click
    */

    if ($current === undefined && window.matchMedia('(max-width: 768px)').matches) {
  
      e?.preventDefault();

      if ($index < $activeIndex) {
        swipe(-1);
      } else {
        swipe(1);
      }
    } else {
      if (titleAndUrl.openInNewTab) {
        window.open(titleAndUrl.url, '_blank');
      } else {
        window.location.href = titleAndUrl.url || '';
      }
    }
  };

  const handleKeyUp = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (
      event.code === 'Space'
      || event.code === 'Enter'
    ) {
      event.preventDefault();
      clickHandler(undefined);
    }
  };

  return (
  <s.StyledAudienceCard 
      aria-label={titleAndUrl?.openInNewTab ? `${titleAndUrl?.title} (opens in a new tab)` : titleAndUrl?.title}
      onClick={clickHandler}
      onFocus={() => {setThisSlide($index);}}
      onKeyUp={handleKeyUp}
      data-audience-card
      tabIndex={0}
    >
      <s.ImageContainer>
        <s.StyledImage
          imageData={image?.gatsbyImage as IGatsbyImageData}
          altText={image?.altText}
        />
      </s.ImageContainer>
    <s.TextContainer>
      <s.Text>
        {titleAndUrl.title}
      </s.Text>
      <ArrowIcon />
    </s.TextContainer>
  </s.StyledAudienceCard>
  );
};

export default AudienceCard;
